export const BASE_NOMINATIM_URL: string = 'nominatim.openstreetmap.org';
export const BASE_OSM_URL: string = 'www.openstreetmap.org';
export const DEFAULT_VIEW_BOX: string = 'viewbox=-25.0000%2C70.0000%2C50.0000%2C40.0000';
